export default __webpack_public_path__ + "static/nzz-e308fef963046d87a2709c884587d73c.svg";